<p class="my-2 pb-2 text-sm border-b text-indigo-700 border-indigo-400">
  {{title}}</p>